import React from 'react';
import Skeleton from '@mui/material/Skeleton';

export function ProfileV2ComponentSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
        marginTop: '2rem',
      }}
      className="qlf-skeleton"
      data-testid="skeleton"
      role="status"
      aria-live="polite"
      // not translated as this is backend rendered and while we have the locale at hand, it's not handy to make i18next work with SSR
      aria-label="Loading level information"
    >
      <Skeleton variant="circular" width="8rem" height="8rem" />
      <Skeleton variant="text" width="12rem" height="3rem" style={{ marginTop: '2rem' }} />
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <Skeleton variant="circular" width="2.25rem" height="2.25rem" />
        <Skeleton variant="text" width="4rem" height="3rem" />
      </div>
    </div>
  );
}
